import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { withLoader, withErrorHandling } from '@/store/thunks/thunkWrappers';

export const deleteUserThunk = createAdminAsyncThunk<
  undefined,
  { id: string }
>(
  'organizationUsers/delete',
  withLoader(
    withErrorHandling(
      async({ id }, { extra: { usersService } }) => {
        await usersService.deleteUser(id);
        return undefined;
      }
    )
  )
);
